import React from "react";
import { format } from "date-fns";
import { Alert, AlertTitle } from "@mui/material";
import styled from "@emotion/styled";
import { useListAndSearchAllApplicationProperties } from "@rentablo/api/apiv1";

const Wrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(6)};
`;

export const DashboardNotificationManager = () => {
  const { data } = useListAndSearchAllApplicationProperties({
    propertyName: ["NOTIFICATION"],
    parentPropertyName: ["DASHBOARD"],
    validFrom: format(new Date(), "yyyy-MM-dd"),
    validTo: format(new Date(), "yyyy-MM-dd"),
  });

  if (data?.applicationProperties?.length) {
    const [notification] = data?.applicationProperties ?? [];

    return (
      <Wrapper>
        <Alert severity="info">
          <AlertTitle>{notification?.value}</AlertTitle>
          {notification?.comment}
        </Alert>
      </Wrapper>
    );
  }

  return null;
};
